export default {
  brand: 'Laplace',
  badge: 'Запрос демо',
  title: 'Связаться с Laplace',
  intro:
    'Чтобы подготовиться к демо-звонку, расскажите немного о себе и о задачах, которые хотите решить с Laplace.',
  partnerNote:
    'Если вы хотите продавать услуги внедрения на базе Laplace или стать партнёром — напишите нам.',

  firstName: 'Имя',
  lastName: 'Фамилия',
  workEmail: 'Рабочая почта',
  workEmailPlaceholder: 'you@company.com',
  phone: 'Телефон',
  phonePlaceholder: '+7 (900) 000-00-00',
  language: 'Язык общения',
  languagePlaceholder: 'Выберите язык',
  langRussian: 'Русский',
  langEnglish: 'Английский',
  region: 'Регион (штаб-квартира)',
  regionPlaceholder: 'Выберите регион',
  headcount: 'Размер компании',
  headcountPlaceholder: 'Выберите размер',
  useCase: 'Как вы хотите использовать Laplace?',
  useCasePlaceholder:
    'Расскажите о команде, источниках знаний и задачах, которые хотите решить.',

  consent:
    'Я согласен получать маркетинговые сообщения от Laplace о продуктах, услугах и событиях.',
  privacyNoticePrefix:
    'Отправляя форму, вы соглашаетесь на обработку Laplace ваших персональных данных для ответа на запрос. Laplace использует контактные данные, чтобы связаться с вами по поводу продуктов и услуг. Вы можете отписаться в любой момент. Подробнее — в ',
  privacyPolicyLink: 'Политике конфиденциальности',
  privacyNoticeSuffix: '.',

  regionEurope: 'Европа',
  regionNorthAmerica: 'Северная Америка',
  regionLatam: 'Латинская Америка',
  regionMea: 'Ближний Восток и Африка',
  regionApac: 'Азиатско-Тихоокеанский регион',
  regionCis: 'СНГ / Россия',
  regionOther: 'Другой регион',

  submit: 'Отправить',
  submitting: 'Отправляем…',
  submitError:
    'Не удалось отправить запрос. Попробуйте ещё раз через несколько секунд.',
  back: 'На главную',

  successTitle: 'Спасибо за заявку!',
  successBody:
    'Мы получили ваш запрос на демо и свяжемся с вами в ближайшее время.',
  successBack: 'Вернуться на главную',

  required: 'Обязательное поле',
  invalidEmail: 'Введите корректный рабочий email',
  invalidPhone: 'Введите корректный номер телефона',
}
